import { createFileRoute } from '@tanstack/react-router';

import { getLocalizedTitle } from '../title';

export const Route = createFileRoute('/_app/users/$userId/edit')({
  head: () => ({
    meta: [
      {
        title: getLocalizedTitle('users.edit.page_title', 'User Profile'),
      },
    ],
  }),
});
